import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'tripsToUk'>;

type Params = Fields;

export function getPageStatus({ tripsToUk }: Params): { complete: boolean } {
  let complete = false;
  if (!tripsToUk || tripsToUk.length === 0) {
    complete = false;
  } else {
    complete = !tripsToUk.some(trip => {
      return trip.arrivalDate === '' || trip.departureDate === '' || trip.purpose === '';
    });
  }

  return { complete };
}
